import { render, staticRenderFns } from "./CreatorAccountDialog.vue?vue&type=template&id=b12c9876&scoped=true&"
import script from "./CreatorAccountDialog.vue?vue&type=script&lang=js&"
export * from "./CreatorAccountDialog.vue?vue&type=script&lang=js&"
import style0 from "./CreatorAccountDialog.vue?vue&type=style&index=0&id=b12c9876&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12c9876",
  null
  
)

export default component.exports